import { render, staticRenderFns } from "./VoDModalSwipers.vue?vue&type=template&id=4f40b7f4"
import script from "./VoDModalSwipers.vue?vue&type=script&lang=ts"
export * from "./VoDModalSwipers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports